var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.042,
    viewBox: "0 0 40 48.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_371",
    "data-name": "Groupe 371",
    transform: "translate(-456.429 -134.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_405-4",
    "data-name": "Groupe 405-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_575",
    "data-name": "Trac\\xE9 575",
    d: "M490.429,182.736h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.437.059,14.748,0,17.6-.028,3.555-.039,3.624-.038,4.276.614.4.4,5.133,6.356,6.048,7.512,6.063,7.662,6.063,7.753,6.063,8.623v25.279A6.007,6.007,0,0,1,490.429,182.736Zm-28-44a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V152.03c-1.46-2.042-8.436-10.829-10.492-13.338-.461,0-1.112.008-1.852.016C477.22,138.739,471.89,138.794,462.424,138.736Z",
    fill: "#eb8909"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_551",
    "data-name": "Trac\\xE9 551",
    d: "M481.546,162.85a1,1,0,0,1,0,1.682l-9.151,7.168a1,1,0,0,1-1.541-.841V156.523a1,1,0,0,1,1.541-.842Z",
    fill: "#eb8909"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.f983655e7e45672bf36d7ec4f854ae1a.svg";
export { ForwardRef as ReactComponent };